import { render, staticRenderFns } from "./UnsubscribeConfirmation.vue?vue&type=template&id=58fb10a4&scoped=true&"
import script from "./UnsubscribeConfirmation.vue?vue&type=script&lang=js&"
export * from "./UnsubscribeConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./UnsubscribeConfirmation.vue?vue&type=style&index=0&id=58fb10a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fb10a4",
  null
  
)

export default component.exports